function resetAddToCart() {
	if ($('#add-to-cart .cta-button-term').text() === 'Added') {
		$('#add-to-cart').prop('disabled', false);
		$('#add-to-cart .cta-button-term').text('Add to cart');
	}
}

function openDrawer(drawer) {
	if (drawer.length) {
		if (checkTransition(body)) {
			drawer.show().scrollTop(0).attr('data-state', 'opening');
			setTimeout(() => {
				drawer.attr('data-state', 'open');
				body.removeClass('transition');
			}, timing*2);
		}
	}
}

function closeDrawer(drawer) {
	if (drawer.length) {
		if (checkTransition(body)) {
			$('[data-drawer]').removeClass('active');
			drawer.attr('data-state', 'close');
			setTimeout(() => {
				drawer.hide().find('.drawer-backdrop').removeClass('active');
				body.removeClass('transition');
			}, timing*2);
			resetAddToCart();
		}
	}
}

window.location.search == '?minicart' && $('#drawer-minicart').show().attr('data-state', 'open');

// Open drawer
$(document).on('click', '[data-drawer]', function () {
	$(this).addClass('active');
	openDrawer($($(this).data('drawer')));
});

// Close drawer
$(document).on('click', '.drawer-backdrop, .drawer-header button', function () {
	closeDrawer($(this).closest('.drawer-wrapper'));
});

// Mobile
if (isMobile) {

	// let tsY = 0;
	// let teY = 0;
	// $('._modal').on('touchstart', function(event){
	// 	tsY = event.changedTouches[0].screenY;
	// }).on('touchend', function(event){
	// 	teY = event.changedTouches[0].screenY;
	// 	if($(this).scrollTop() <= 0 && !$('._module-popup').hasClass('_visible')){
	// 		if(teY >= tsY && (teY - tsY > 50)){
	// 			escPopUp()
	// 		}
	// 	}
	// });

// Desktop
} else {

	// Backdrop animation
	$(document).on('mouseenter mousemove', '.drawer-backdrop', function () {
		$(this).addClass('active');
	}).on('mouseout', '.drawer-backdrop', function () {
		if($(this).closest('.drawer-wrapper').attr('data-state') === 'open'){
			$(this).removeClass('active');
		}
	});

	// Keyboard navigation
	document.addEventListener('keyup', (e) => {
		if (e.key === 'Escape') {
			if (!body.hasClass('transition')) {
				$('.drawer-wrapper:visible').length && closeDrawer($('.drawer-wrapper:visible'));
			}
		}
	});

}